var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-5 mb-5"},[_c('v-progress-circular',{attrs:{"size":_vm.size ? _vm.size : 70,"width":7,"color":"#76be1a","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }